//---------------
// extract names
//---------------
export default function extractNames(objArray) {
  if (!Array.isArray(objArray)) {
    console.warn('extractNames: expected array, got', objArray)
    return []
  }
  return objArray.map((a) => a.name)
}
